import React from 'react';
import { useIntl } from 'react-intl';

import { StaticContentTitle } from '@/components/Base/StaticContent/StaticContent.styles';

import { Table, Td, Th, Thead, Tr, Wrapper } from './ConditionsTable.styles';

function ConditionsTable() {
  const { formatMessage } = useIntl();

  return (
    <Wrapper id="conditionsTable" className="sections">
      <StaticContentTitle as="h2">
        {formatMessage({
          id: 'staticContent.anchorLinks.map.title.conditionsTable',
        })}
      </StaticContentTitle>

      <Table className="staticTable">
        <Thead>
          <Tr>
            <Th>
              {formatMessage({
                id: `staticContent.conditionsTable.parameters`,
              })}
            </Th>

            <Th>
              {formatMessage({
                id: `staticContent.conditionsTable.conditions`,
              })}
            </Th>
          </Tr>
        </Thead>

        <tbody>
          {Array.from({ length: 5 }).map((row, index) => (
            <Tr key={index}>
              <Td>
                {formatMessage({
                  id: `staticContent.conditionsTable.parameters.${index}`,
                })}
              </Td>

              <Td>
                {formatMessage({
                  id: `staticContent.conditionsTable.conditions.${index}`,
                })}
              </Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </Wrapper>
  );
}

export default ConditionsTable;
